import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { PriceDisplayChangeOnboarding } from '@shared-ui/lodging-property-listing';
export const PriceDisplayChangeOnboardingSharedUiWrapper = inject('searchResults')(observer(({
  searchResults
}) => {
  if (!(searchResults === null || searchResults === void 0 ? void 0 : searchResults.priceDisplayChangeOnboardingAction) || !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.shoppingJoinListContainer) || !(searchResults === null || searchResults === void 0 ? void 0 : searchResults.contents)) {
    return null;
  }
  const resultData = {
    summary: {
      priceDisplayChangeOnboardingAction: searchResults.priceDisplayChangeOnboardingAction,
      shoppingJoinListContainer: searchResults.shoppingJoinListContainer,
      shoppingInvokeFunctionParams: searchResults.shoppingInvokeFunctionParams,
      contents: searchResults.contents
    }
  };
  return React.createElement(PriceDisplayChangeOnboarding, {
    data: resultData
  });
}));
PriceDisplayChangeOnboardingSharedUiWrapper.displayName = 'PriceDisplayChangeOnboardingSharedUiWrapper';